
import { Box, Flex, Text } from "@chakra-ui/react";
import 'animate.css';
import { useEffect, useState } from "react";
import { RiCloseLine } from "react-icons/ri";
import { getLocalUserProfile } from "../../services/auth.service";
import userService from "../../services/user.service";

const UserNotificationsModal = ({ setIsOpen }: { setIsOpen: any }) => {
    
    const [notifications, setUserNotifications] = useState<any>()
    useEffect(() => {
        const user = getLocalUserProfile();
        if ( user){
            userService.getUserNotifications(user.uuid)
            .then((response) => {
             setUserNotifications(response)
             
         })
         .catch((err) => err)
        }
        
    }, [])

    return (
        <>
            <Box className="animate__animated animate__slideInRight" minH='98vh' bg='white' position='absolute' right={0} top={0} zIndex={10} width='25vw'>
                <Flex pt={'20px'} px='10px'  height='70px' borderBottom={'2px solid lightgray'} boxShadow={'base'} justifyContent={'space-between'}>
                    <Text>Notifications</Text>
                    <Text cursor={'pointer'} onClick={() => { setIsOpen(false) }}><RiCloseLine /></Text>
                </Flex>
            </Box>

        </>
    );
};

export default UserNotificationsModal;